// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderButton_loader__qmma2","l23":"LoaderButton_l23__dRgVU"};